import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { NodesService } from '../../../../services/nodes/nodes.service';
import { ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Location } from '@angular/common';
import { NodeEnvelope } from '../../../../models/net/envelope/node-envelope';
import { NodeRole } from '../../../../models/data/app-core/node-role';
import { Role } from '../../../../models/data/identity/role';
import { EditorComponent } from '../../../base/editor/editor.component';

@Component({
    selector: 'app-node',
    templateUrl: './node.component.html',
    styleUrls: ['./node.component.css', '../../../../app.component.css']
})

export class NodeComponent extends EditorComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Role", "Delete"];
    public nodeRolesDatasource: any = null;
    public nodeId: number = 0;
    public parentNodeId: number = 0;
    public availableRoles: Role[] = [];
    public selectedRole: Role | null = null;

    @ViewChild(MatSort) sort = new MatSort();
    @ViewChild(MatPaginator) paginator: any;

    public constructor(public override appService: AppService,
                       public override itemService: NodesService, 
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "node", "nodes");
    }

    public override initializeEnvelope = (envelope: NodeEnvelope | null): void => {

        this.itemEnvelope = new NodeEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
        this.nodeRolesDatasource = new MatTableDataSource((this.itemEnvelope as NodeEnvelope).Document.NodeRoles);
        const roleIds: number[] = (this.itemEnvelope as NodeEnvelope).Document.NodeRoles.map((i: NodeRole) => i.RoleId);
        const availableRoles: Role[] = (this.itemEnvelope as NodeEnvelope).Roles.filter((i: Role) => !roleIds.includes(i.RoleId));
        this.availableRoles = this.appService.cloneObject(availableRoles);
        this.searchRoute = "node/" + (this.itemEnvelope as NodeEnvelope)?.Document?.Item?.ParentNodeId ?? 0;
    }

    public roleSelected = (): void => {

        let s: string = this.selectedRole?.UID ?? "";
    }

    public addSelectedRoleToNode = (): void => {

        const nodeRole: NodeRole = {
            NodeRoleId: 0,
            NodeId: this.itemEnvelope?.Document?.Item?.NodeId == null ? 0 : this.itemEnvelope?.Document?.Item?.NodeId,
            RoleId: this.selectedRole?.RoleId == null ? 0 : this.selectedRole?.RoleId,
            CreatedOnUTC: new Date(),
            CreateUserUID: ""
        };

        (this.itemEnvelope as NodeEnvelope)?.Document?.NodeRoles.push(nodeRole);

        this.nodeRolesDatasource = new MatTableDataSource((this.itemEnvelope as NodeEnvelope)?.Document?.NodeRoles);

        const itemIndex: number = this.availableRoles.map((i: any) => i.RoleId).indexOf(this.selectedRole?.RoleId, 0);

        if (itemIndex > -1) {

            this.availableRoles.splice(itemIndex, 1);
        }

        this.selectedRole = null;
    }

    public deleteRole = (nodeRole: NodeRole): void => {

        const itemIndex: number | undefined = (this.itemEnvelope as NodeEnvelope)?.Document?.NodeRoles.map((i: NodeRole) => i.NodeRoleId).indexOf(nodeRole.NodeRoleId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            (this.itemEnvelope as NodeEnvelope)?.Document?.NodeRoles.splice(itemIndex, 1);
            this.nodeRolesDatasource = new MatTableDataSource((this.itemEnvelope as NodeEnvelope)?.Document?.NodeRoles);
        }

        const availableRole: Role | undefined = (this.itemEnvelope as NodeEnvelope)?.Roles.find((i: Role) => i.RoleId == nodeRole.RoleId);

        if (availableRole) {

            this.availableRoles.push(availableRole);
        }
    }

    public getRoleUIDFromRoleId = (roleId: number): string => {

        let result: string = "";

        let role: Role | undefined = (this.itemEnvelope as NodeEnvelope)?.Roles.find((i: Role) => i.RoleId == roleId)

        if (role) {

            result = role.UID;
        }

        return result;
    }
}
